import {
    useContext,
    type FC
} from "react";
import {
    Platform
} from "react-native";
import type ITimelineTimeProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import {
    TimelinePositionContext,
    useTimelineContext
} from "../../context";
import {
    renderAccessibleText
} from "../../../../helpers/accessibility";
import {
    getTimelineTimeTexts
} from "../../util";
import Tooltip from "../../../tooltip";

const TimelineTime: FC<ITimelineTimeProps> = ({
    isTooltipVisible,
    customTheme,
    date
}) => {
    const context = useTimelineContext({
        part: "Item"
    });

    const position = useContext(TimelinePositionContext);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const pointerType = usePointerType();

    if(!context) {
        return null;
    }

    const texts = getTimelineTimeTexts({
        timeBehaviour: context.timeBehaviour,
        isDayGrouped: position.isDayGrouped,
        locale: context.activeLocale,
        isToday: position.isToday,
        now: context.now,
        localize,
        date
    });

    const isShowTooltip = Platform.OS === "web" && pointerType === "fine";

    const renderText = () => {
        return renderAccessibleText({
            label: texts.accessibleText,
            style: stylesheet.container,
            variant: "bodySmallSize",
            children: texts.text,
            customTheme,
            color: "low"
        });
    };

    if(!isShowTooltip) {
        return renderText();
    }

    return <Tooltip
        isOpen={isTooltipVisible ? true : undefined}
        title={texts.absoluteText}
        customTheme={customTheme}
        side="top"
    >
        {renderText()}
    </Tooltip>;
};
export default TimelineTime;
